'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('e-form-list', {
      url: '/e-form/list',
      template: '<e-form-list></e-form-list>',
        authenticate: 'suite-admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/e-form/list/e-form-list.routes.js